import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import Button from '@ui-library/button';
import { H4 } from '@ui-library/typography';
import { Flex } from '../misc';

interface Props {
  title: string | JSX.Element;
  onClose: () => void;
  content: JSX.Element | string;
  onSave?: () => void;
  isSaveDisabled?: boolean;
  loading?: boolean;
  saveLabel?: string;
  saveLabelBtnType?: string;
  showClose?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  modalClass?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLElement>) => void;
  cancelLabel?: string;
  cancelLabelBtnType?: string;
}

export default ({
  title,
  onClose,
  content,
  onSave = () => null,
  isSaveDisabled = false,
  loading = false,
  saveLabel = '',
  showClose = true,
  size = 'sm',
  modalClass = '',
  onKeyDown = () => null,
  saveLabelBtnType = '',
  cancelLabel = 'Cancel',
  cancelLabelBtnType = 'secondary',
}: Props) => {
  const sizeClass = `${size}_modal`;
  const buttonType = saveLabelBtnType.length > 0 && { [saveLabelBtnType]: true };
  const cancelBtnType = cancelLabelBtnType.length > 0 && { [cancelLabelBtnType]: true };

  return (
    <div
      className={`custom_modal ${sizeClass} ${modalClass}`}
      onKeyDown={onKeyDown}
      tabIndex={-1}
      role="button"
      data-testid="customModal"
      onClick={(e) => e.stopPropagation()}
    >
      <div id="custom_modal__header">
        <Button textSecondary shape="circle" onClick={onClose} data-testid="btnCloseIcon">
          <CloseOutlined />
        </Button>
        <H4>{title}</H4>
      </div>
      <div id="custom_modal__body">{content}</div>
      <Flex id="custom_modal__footer">
        {saveLabel.length > 0 && (
          <Button
            {...buttonType}
            className="m-l-sm"
            disabled={isSaveDisabled}
            onClick={onSave}
            loading={loading}
            name={saveLabel}
            data-testid="btnSave"
          />
        )}
        {showClose && (
          <Button {...cancelBtnType} onClick={onClose} name={cancelLabel} data-testid="btnClose" />
        )}
      </Flex>
    </div>
  );
};
